<script>
import colors from 'tailwindcss/colors';
import {format} from "date-fns";
import {nl} from "date-fns/locale";

export default {
  name: 'PerformanceChart',
  // ADD style="max-width: 100%" when using
  emits: [],
  mixins: [],
  props: {
    chartData: {},
    dateFormatTooltipTitle: String,
    dateFormatXAxis: String,
  },
  computed: {
    chartDataSet() {
      return {
        datasets: [
          {
            data: this.chartData,
            parsing: {
              xAxisKey: 'start_date',
              yAxisKey: 'actual_yield_in_kwh',
            },
            borderRadius: 12,
            backgroundColor: () =>
              getComputedStyle(document.documentElement)
                .getPropertyValue('--color-background-chart')
                .trim(),
          },
        ],
      };
    },
    chartOptions() {
      return {
        plugins: {
          legend: {
            display: false,
          },
          tooltip: {
            enabled: true,
            backgroundColor: '#334155',
            yAlign: 'bottom',
            displayColors: false,
            titleFont: {
              size: 16,
            },
            bodyFont: {
              size: 15,
            },
            callbacks: {
              title: (contexts) => {
                const dateTime = contexts[0].label;
                const date = new Date(dateTime);

                return format(date, this.dateFormatTooltipTitle, {locale: nl});
              },
              label: (data) => {
                const value =
                  data.dataset.data[data.dataIndex].actual_yield_in_kwh;
                return Math.round(value) + ' kWh';
              },
            },
          },
        },
        scales: {
          y: {
            ticks: { count: 6 },
          },
          x: {
            grid: {
              display: false,
            },
            ticks: {
              minRotation: 0,
              maxRotation: 0,
              callback: (index) => {
                let date = new Date(this.chartData[index].start_date);
                return format(date, this.dateFormatXAxis, {locale: nl});
              },
            },
          },
        },
      };
    },
  },
  methods: {},
};
</script>

<template>
  <Chart type="bar" :data="chartDataSet" :options="chartOptions"/>
</template>

<style scoped></style>
